import { AtendimentoType } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type MeusAtendimentosFilters = {
  paciente: string
  protocolo: string
  empresa?: IOption<number>
  estado?: IOption<number>
  tipoAtendimento?: IOption<AtendimentoType>
  especialidade?: IOption<number>
  /** Datas puras (aaaa-mm-dd) do <input type="date">. */
  solicitacao: string
  inicio: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<MeusAtendimentosFilters>({
  paciente: '',
  protocolo: '',
  empresa: undefined,
  estado: undefined,
  tipoAtendimento: undefined,
  especialidade: undefined,
  solicitacao: '',
  inicio: '',
})
